<template>
  <div>
    <!--기본정보-->
    <field-select-module
      title="기본정보(담당자 정보)"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
    />
    <!-- 종사자 정보 -->
    <div class="mt-10">
      <h5 class="mt-6 mb-4"><i class="dot"></i> 종사자 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>설립</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
          <ml-input v-else v-model="form.inputA_10" disabled />
        </div>
        <div>
          <div>구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" disabled/>
        </div>
        <div>
          <div>학교(기관)명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input v-else v-model="form.inputA_3" disabled />
        </div>
        <div>
          <div>이름</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <ml-input v-else v-model="form.inputA_8" disabled />
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input v-else v-model="form.inputA_6" disabled />
        </div>
      </div>
    </div>

    <!-- 폐암 건강검진 결과 -->
    <div class="mt-10">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 폐암 건강검진 결과</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div>검진일</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputB_1 }}
          </div>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputB_1"
            readonly
          />
        </div>
        <div class="custom-row">
          <div>이상소견</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputB_2 }}
          </div>
          <div v-else class="flex" >
            <vs-radio style="width: 50px;" :value="form.inputB_2" vs-value="있음" vs-name="이상소견" disabled>있음</vs-radio>
            <vs-radio style="width: 50px;" class="ml-4 " :value="form.inputB_2" vs-value="없음" vs-name="이상소견" disabled>없음</vs-radio>
            <vs-select
              v-if="form.inputB_2 === '있음'"
              class="ml-4"
              style="width: 120px;"
              autocomplete
              v-model="form.inputB_2_value"
              placeholder="선택하세요."
            >
              <vs-select-item
                v-for="option in ['2', '2b', '3', '4A', '4B', '4X', '5']"
                :key="option"
                :text="option" :value="option" />
            </vs-select>
          </div>
        </div>
        <div class="custom-row"></div>
      </div>
      <div class="writeGridContainer gap-x-12 gap-y-4 mt-4">
        <div class="custom-row col-span-12" style="align-items: start;">
          <div>판정구분에 따른 권고사항</div>
          <div v-if="isPrint" class="print-textarea">
            {{ form.inputB_4 }}
          </div>
          <ml-textarea
            v-else
            readonly
            v-model="form.inputB_4"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="writeGridContainer gap-x-12 gap-y-4 mt-4">
        <div class="custom-row col-span-12" style="align-items: start;">
          <div>폐결절외 기타 권고사항</div>
          <div v-if="isPrint" class="print-textarea">
            {{ form.inputB_5 }}
          </div>
          <ml-textarea
            v-else
            readonly
            v-model="form.inputB_5"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 폐암 정밀검진 결과 -->
    <div class="mt-10">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 폐암 정밀검진 결과</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div>검진일</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_1 }}
          </div>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputC_1"
            :readonly="board.readonly"
          />
        </div>
        <div class="custom-row">
          <div>정밀검진 결과</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_2 }}
          </div>
          <div v-else class="flex" >
            <vs-radio style="width: 80px;" v-model="form.inputC_2" vs-value="폐암판정">폐암판정</vs-radio>
            <vs-radio style="width: 80px;" class="ml-4 " v-model="form.inputC_2" vs-value="폐암아님">폐암아님</vs-radio>
          </div>
        </div>
        <div class="custom-row"></div>
      </div>
      <div class="writeGridContainer gap-x-6 gap-y-4 mt-4">
        <div class="custom-row col-12">
          <div>비고</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_3 }}
          </div>
          <ml-input v-else class="w-full" v-model="form.inputC_3"/>
        </div>
      </div>
    </div>


    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    />

    <vs-popup
      id="popupReportList"
      title="폐암검진결과"
      :active.sync="showPopup"
    >
      <div class="w-full flex flex-row justify-between items-center gap-4 p-6">
        <div class="flex-1 flex flex-row items-center gap-4">
          <search-nav-start-end label="작성일" v-model="search.date" />
          <search-nav-item-select
            :label="$t('search.검색조건')"
            v-model="search.searchType"
            :list="searchTypes"
          />
          <search-nav-item-keyword
            :label="$t('search.키워드')"
            v-model="search.searchKeyword"
          />
        </div>
        <vs-button color="secondary" @click="handleClickSearch">
          검색
        </vs-button>
      </div>
      <vs-table
        stripe
        ref="table"
        :sst="true"
        :max-items="page.perPage"
        :data="reportList"
        noDataText="데이터가 없습니다"
      >
        <template slot="thead">
          <vs-th class="w-1/12" style="min-width: 100px"> No. </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 구분(설립별) </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 학교(기관)명 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 이름 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 구분 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 세부구분 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 직종 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 이상소견 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 작성자 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 작성일 </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            v-for="(item, index) in data"
            :key="index"
            class="cursor-pointer"
            :class="checkWarning(item.inputB_2_value)  ? '' : 'disabled'"
            @click.native="() => handleItemClickDetail(item, checkWarning(item.inputB_2_value))"
          >
            <vs-td>{{ item.id }}</vs-td>
            <vs-td>{{ item.inputA_2 }}</vs-td>
            <vs-td>{{ item.inputA_3 }}</vs-td>
            <vs-td>{{ item.inputA_8 }}</vs-td>
            <vs-td>{{ item.inputA_5 }}</vs-td>
            <vs-td>{{ item.inputA_6 }}</vs-td>
            <vs-td>{{ item.inputA_7 }}</vs-td>
            <vs-td>{{ item.inputB_2 === '있음' ? item.inputB_2_value : "없음" }}</vs-td>
            <vs-td>{{ item.stdInfo.writer_name }}</vs-td>
            <vs-td>{{ getCreatedDate(item.created_at) }}</vs-td>

          </vs-tr>
        </template>
      </vs-table>
      <div class="vs-con-table mb-6">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="page.lastPage ? page.lastPage : 1"
            :value="page.current"
            @change="handleChangePage"
          />
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import PopupProjectSetting from "@/views/project/PopupProjectSetting.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import TrainingDisasterClassSelector from "@/components/selector/TrainingDisasterClassSelector.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import { valueDisasters } from "@/util/DisasterDataUtil";
import HttpRequest from "@/util/HttpRequest";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import moment from "moment";

export default {
  components: {
    EmployeeSelector,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    TrainingDisasterClassSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    reportList() {
      if (this.$store.state.board.postListInfo.data) {
        const list = this.$store.state.board.postListInfo.data.map((item) => {
          return { id: item.id, ...this.getContent(item).body };
        });
        return list
      } else return [];
    },
  },
  data() {
    return {
      customButton: null,
      showPopup: false,
      searchTypes: [
        { text: '구분(설립별)', value: 'inputA_2' },
        { text: '학교(기관)명', value: 'inputA_3' },
        { text: '이름', value: 'inputA_8' },
        { text: '구분', value: 'inputA_5' },
        { text: '세부구분', value: 'inputA_6' },
        { text: '직종', value: 'inputA_7' },
        { text: '이상소견', value: 'inputB_2_value' },
        { text: '작성자', value: 'stdInfo.writer_name' },
      ],

      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },

      // 검색
      search: {
        date: "", // 작성일
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      form: {
        stdInfo: {},
        fileList: [],

        inputA_1: '',
        inputA_2: '', // 구분
        inputA_3: '', // 학교(기관)명
        inputA_4: '',
        inputA_5: '',
        inputA_6: '', // 직종
        inputA_7: '',
        inputA_8: '', // 이름
        inputA_9: '',
        inputA_10: '', // 설립: 공립, 국립, 사립
        inputA_11: '',

        inputB_1: '', // 건강검진 검진일
        inputB_2: '없음', // 이상소견
        inputB_2_value: '',
        inputB_3: '',
        inputB_4: '', // 판정구분에 따른 권고사항
        inputB_5: '', // 폐결절외 기타 권고사항

        inputC_1: '', // 정밀검진 검진일
        inputC_2: '', // 정밀검진 결과
        inputC_3: '', // 비고
      },

      divideList: [
        "급식종사자",
        "시설관리자",
        "통학차량 관련자",
        "미화원",
        "당직전담원",
      ],
      subDivideList: [
        "영양교사",
        "영양사",
        "조리사",
        "조리실무사"
      ],
      jobList: ["공무원", "공무직", " 임기제", "기간제", "기능직", "근로자", "공공근로", "노인 일자리", "장애인 일자리", "지역공동체", "자활", "기타"],
    };
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          중대재해발생_사업장명: [],
          중대재해발생_재해형태: [],
        };

        value.summary["중대재해발생_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["중대재해발생_재해형태"].push({
          [this.form.inputD_3]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  created() {
    if (this.value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }

      this.initEmployeeList();
    }
  },
  mounted() {
    /** 재해 발생 보고서 불러오기 버튼 추가 */
    this.customButton = document.createElement("button");
    this.customButton.className =
      "vs-component vs-button ml-4 vs-button-secondary vs-button-border";
    this.customButton.innerText = "폐암검진결과 불러오기";
    this.customButton.addEventListener("click", this.onClickLoadBtn);

    const btnsContainer = document.getElementById("right-button-container");
    btnsContainer.insertAdjacentElement("afterbegin", this.customButton);
  },
  destroyed() {
    this.customButton.removeEventListener("click", this.onClickLoadBtn);
  },
  methods: {
    async initEmployeeList() {
      console.log('initEmployeeList')
      const page = 1;
      const perPage = 10000;
      const projectId = this.$route.params.proj_id;

      const payload = {
        projectId,
        page,
        perPage,
      };

      this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload).then((result) => {
        console.log(result)
      })
    },

    checkWarning (value) {
      if ( value === '4A' || value === '4B' || value === '4X') {
        return true
      }
      return false
    },
    onClickLoadBtn() {
      this.loadReport();
      this.showPopup = true;
    },
    handleClickSearch() {
      this.page.current = 1;
      this.loadReport();
    },
    handleChangePage(page) {
      this.page.current = page;
      this.loadReport();
    },
    async loadReport() {
      const boardId = 502;
      const projectId = this.$route.params.proj_id;
      const page = this.page.current;
      const perPage = this.page.perPage;
      const { date, searchType, searchKeyword } = this.search;

      const conditions = []
      conditions.push({
        operator: "IN",
        value: "4A,4B,4X",
        key: "body.inputB_2_value",
      })
      if (date.sDate) {
        conditions.push({
          operator: ">=",
          value: date.sDate,
          key: "created_at",
        })
      }
      if (date.eDate) {
        conditions.push({
          operator: "<=",
          value: date.eDate,
          key: "created_at",
        })
      }
      if (!!searchType && !!searchKeyword) {
        conditions.push({
          operator: "LIKE",
          value: `%${searchKeyword}%`,
          key: `body.${searchType}`,
        })
      }


      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        conditions,
      });

      const data = this.$store.state.board.postListInfo;
      this.page.current = data.current_page;
      this.page.lastPage = data.last_page;
    },
    handleItemClickDetail(data, enabled) {
      if (enabled) {
        this.form.inputA_1 = data.inputA_1;
        this.form.inputA_2 = data.inputA_2;
        this.form.inputA_3 = data.inputA_3;
        this.form.inputA_4 = data.inputA_4;
        this.form.inputA_5 = data.inputA_5;
        this.form.inputA_5 = data.inputA_5;
        this.form.inputA_6 = data.inputA_6;
        this.form.inputA_7 = data.inputA_7;
        this.form.inputA_8 = data.inputA_8;
        this.form.inputA_9 = data.inputA_9;

        this.form.inputB_1 = data.inputB_1;
        this.form.inputB_2 = data.inputB_2;
        this.form.inputB_2_value = data.inputB_2_value;
        this.form.inputB_3 = data.inputB_3;
        this.form.inputB_4 = data.inputB_4;
        this.form.inputB_5 = data.inputB_5;

        this.showPopup = false;
      }
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content;
      }
    },

    getCreatedDate(data) {
      if (data === "") return "";
      return moment(data).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped lang="scss">
.custom-row {
  align-items: center;
  display: flex;
  width: 100%;
  //grid-template-columns: 114px 1fr;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  //padding-right: 12px;
}

#popupReportList::v-deep > .vs-popup {
  width: 90vw !important;

  tr {
    &.disabled,
    &.disabled > td,
    &.disabled > td > span {
      cursor: default;
      color: #999;
    }
  }
}
</style>
